/* EGR — shop pages: store, product, box builder, bulk, checkout */
(function () {
  "use strict";
  const EGR = window.EGR;
  const { $, $$, esc, money, moneyShort, fmtDate, fmtMassPair, qs, storage, round2, fmtNum } = EGR.u;
  const C = EGR.catalog;
  const P = EGR.data.promo;
  const icon = EGR.icon;
  const pricing = EGR.pricing;
  EGR.pages = EGR.pages || {};
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const norm = (s) => String(s || "").toLowerCase().normalize("NFKD").replace(/[^a-z0-9+]/g, "");
  const sizeSlug = (v) => v.title.replace(/\s+/g, "").toLowerCase();
  const SHOP = window.EGR_SHOP || {};
  const hasLots = C.allLots.length > 0;


  /* ================================================================ STORE */
  const FILTERS = [
    { id: "all", label: "All" },
    P.daily.enabled ? { id: "today", label: "Today's list", test: (p) => pricing.isDaily(p) } : null,
    { id: "bestsellers", label: "Bestsellers", test: (p) => p.badges.indexOf("bestseller") >= 0 },
    { id: "blends", label: "Blends", test: (p) => C.isBlend(p) }
  ].concat(EGR.data.categories.map((c) => ({ id: c.id, label: c.label, test: (p) => p.category === c.id }))).filter(Boolean);
  const SORTS = [["featured", "Featured"], ["price-asc", "Price: low to high"], ["price-desc", "Price: high to low"]]
    .concat(hasLots ? [["purity", "Highest purity"], ["newest", "Newest lots"]] : [], [["name", "Name"]]);
  const purityOf = (p) => { const l = C.activeLot(p.variants[0]); return l && l.purity != null ? l.purity : -1; };
  const newestOf = (p) => p.variants.reduce((m, v) => { const l = C.activeLot(v); return l && l.testedAt > m ? l.testedAt : m; }, "");
  const sorters = {
    featured: (a, b) => (a.featuredRank || 99) - (b.featuredRank || 99) || a.title.localeCompare(b.title),
    "price-asc": (a, b) => a.variants[0].price - b.variants[0].price,
    "price-desc": (a, b) => b.variants[0].price - a.variants[0].price,
    purity: (a, b) => purityOf(b) - purityOf(a),
    newest: (a, b) => newestOf(b).localeCompare(newestOf(a)),
    name: (a, b) => a.title.localeCompare(b.title)
  };
  function matchesQuery(p, nq) {
    if (!nq) return true;
    const names = [p.title, p.short, p.handle].concat(p.aliases || []).concat((p.components || []).map((c) => c.name)).map(norm);
    if (names.some((k) => k.includes(nq))) return true;
    if (nq.length >= 3 && norm(p.subtitle).includes(nq)) return true;
    return norm(C.catLabel(p.category)).startsWith(nq);
  }

  EGR.pages.store = {
    ribbon: true,
    title: "Shop · EGR",
    init() {
      const state = {
        f: qs("list") === "today" ? "today" : (qs("cat") && FILTERS.some((f) => f.id === qs("cat")) ? qs("cat") : "all"),
        q: qs("q") || "",
        sort: SORTS.some((s) => s[0] === qs("sort")) ? qs("sort") : "featured"
      };
      const tiles = $("#cat-tiles");
      const inCollection = Array.isArray(SHOP.collectionHandles) ? new Set(SHOP.collectionHandles) : null;
      const pool = inCollection ? C.products.filter((p) => inCollection.has(p.handle)) : C.products;
      const cats = [{ id: "all", label: "All compounds", picks: ["reditide", "bpc-157"] }].concat(P.daily.enabled ? [{ id: "today", label: "Today's list", picks: ["kpv", "semax"] }] : [])
        .concat(EGR.data.categories.map((c) => ({ id: c.id, label: c.label, picks: pool.filter((p) => p.category === c.id).slice(0, 2).map((p) => p.handle) })))
        .filter((c) => c.id === "all" || pool.some((p) => (FILTERS.find((x) => x.id === c.id) || {}).test ? FILTERS.find((x) => x.id === c.id).test(p) : true));
      tiles.innerHTML = cats.map((c) => {
        const f = FILTERS.find((x) => x.id === c.id);
        const n = f && f.test ? pool.filter(f.test).length : pool.length;
        return `<a class="cat-tile" href="store.html?${c.id === "today" ? "list=today" : "cat=" + c.id}" data-filter="${c.id}"><span class="cat-art">${c.picks.map((h) => C.product(h)).filter(Boolean).map((p) => EGR.vial(p)).join("")}</span>${esc(c.label)}<small>${n} item${n === 1 ? "" : "s"}</small></a>`;
      }).join("");

      $("#chips").innerHTML = FILTERS.filter((f) => !f.test || pool.some(f.test)).map((f) => {
        const n = f.test ? pool.filter(f.test).length : pool.length;
        return `<button type="button" class="chip" data-filter="${f.id}" aria-pressed="false">${esc(f.label)}<span class="n">${n}</span></button>`;
      }).join("");
      const sortSel = $("#sort");
      sortSel.innerHTML = SORTS.map(([v, l]) => `<option value="${v}">${l}</option>`).join("");
      const qIn = $("#store-q");
      qIn.value = state.q;
      sortSel.value = state.sort;

      function sync() {
        const params = new URLSearchParams();
        if (state.f === "today") params.set("list", "today"); else if (state.f !== "all") params.set("cat", state.f);
        if (state.q) params.set("q", state.q);
        if (state.sort !== "featured") params.set("sort", state.sort);
        const s = params.toString();
        history.replaceState(null, "", location.pathname + (s ? "?" + s : ""));
      }
      function render() {
        $$("#chips .chip").forEach((c) => c.setAttribute("aria-pressed", c.dataset.filter === state.f));
        // Keep the active chip visible in the scrolling row (moves the row only, never the page).
        const row = $("#chips"), on = $("#chips .chip[aria-pressed='true']");
        if (on && (on.offsetLeft < row.scrollLeft || on.offsetLeft + on.offsetWidth > row.scrollLeft + row.clientWidth)) row.scrollLeft = on.offsetLeft - 8;
        const f = FILTERS.find((x) => x.id === state.f);
        const nq = norm(state.q);
        let list = pool.filter((p) => (!f.test || f.test(p)) && matchesQuery(p, nq));
        list = list.slice().sort(sorters[state.sort] || sorters.featured);
        const label = state.f === "all" ? "" : ` in ${f.label}`;
        const clear = state.f !== "all" || state.q ? ` <button type="button" class="linkish" id="clear-filters" style="font-size:14px">Clear filters</button>` : "";
        $("#meta").innerHTML = `${list.length} compound${list.length === 1 ? "" : "s"}${esc(label)}${state.q ? ` matching “${esc(state.q)}”` : ""}.${clear}`;
        $("#today-banner").innerHTML = state.f === "today"
          ? `<div class="notice info" style="margin-bottom:20px">${icon("clock")}<div><strong>Half price until midnight ET.</strong> ${P.daily.percent}% off up to ${P.daily.maxUnitsPerLine} units per compound. Today’s prices run for another <span class="tnum" data-countdown="daily"></span>.</div></div>` : "";
        const grid = $("#grid");
        grid.innerHTML = list.length ? list.map((p) => EGR.card(p)).join("")
          : `<div class="empty" style="grid-column:1/-1">${icon("search", "icon-lg")}<h3>No compounds match.</h3><p>Try another name, an alias, or clear the filters.</p><div class="btn-row"><button type="button" class="btn" id="clear-empty">Clear filters</button></div></div>`;
        const clr = $("#clear-filters") || $("#clear-empty");
        [$("#clear-filters"), $("#clear-empty")].forEach((b) => b && b.addEventListener("click", () => { state.f = "all"; state.q = ""; qIn.value = ""; sync(); render(); }));
        void clr;
      }
      document.addEventListener("click", (e) => {
        const t = e.target.closest("[data-filter]");
        if (!t) return;
        e.preventDefault();
        state.f = t.dataset.filter;
        sync(); render();
        if (t.classList.contains("cat-tile")) $(".store-tools").scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
      });
      let deb;
      qIn.addEventListener("input", () => { clearTimeout(deb); deb = setTimeout(() => { state.q = qIn.value.trim(); sync(); render(); }, 120); });
      sortSel.addEventListener("change", () => { state.sort = sortSel.value; sync(); render(); });
      sync(); render();
    }
  };

  /* ============================================================== PRODUCT */
  const prod = C.product(SHOP.productHandle || qs("p"));
  function pickVariant(p) {
    const id = qs("variant"), s = qs("v");
    return (id && p.variants.find((v) => v.id === id)) || (s && p.variants.find((v) => sizeSlug(v) === s.toLowerCase())) || p.variants[0];
  }
  EGR.pages.product = {
    title: prod ? `${prod.title} · EGR` : "Compound not found · EGR",
    init() {
      const root = $("#product");
      if (!prod) {
        root.innerHTML = `<div class="nf"><div><h1 class="headline">We couldn’t find that compound.</h1><p class="lede muted" style="margin-top:14px">It may have been renamed or removed from the catalog.</p><div class="btn-row center" style="margin-top:28px"><a class="btn" href="store.html">Shop all compounds</a><button type="button" class="more linkish" style="font-size:17px" data-open-search>Search</button></div></div></div>`;
        return;
      }
      const p = prod;
      let v = pickVariant(p);
      let qty = 1;
      let buyBar = () => {};
      const daily = pricing.isDaily(p);
      const flags = [
        daily ? `<span class="badge badge-sale">Today −${P.daily.percent}%</span>` : "",
        p.badges.indexOf("bestseller") >= 0 ? `<span class="badge badge-ink">Bestseller</span>` : "",
        C.isBlend(p) ? `<span class="badge badge-blue">Blend</span>` : "",
        p.variants.some((x) => x.stock !== 0) ? `<span class="badge badge-pass" id="stock-badge">${icon("check", "icon")}In stock</span>` : `<span class="badge" id="stock-badge">Sold out</span>`
      ].join("");
      const seq = EGR.parseSequence(p.spec.sequence);

      root.innerHTML = `<div class="container page-top">
<nav class="crumbs" aria-label="Breadcrumb"><a href="store.html">Shop</a><span>›</span><a href="store.html?cat=${p.category}">${esc(C.catLabel(p.category))}</a><span>›</span>${esc(p.title)}</nav>
<div class="buy" id="overview">
<div class="buy-media">
<div class="stage buy-stage tone-${p.tone}" id="buy-stage" aria-live="polite"></div>
${p.variants.length > 1 ? `<div class="buy-thumbs" role="group" aria-label="Sizes">${p.variants.map((x) => `<button type="button" data-thumb="${x.id}" aria-label="${esc(x.title)}" aria-pressed="false">${EGR.vial(p, { variant: x })}</button>`).join("")}</div>` : ""}
</div>
<div class="buy-info">
<div class="buy-flags">${flags}</div>
<h1>${esc(p.title)}</h1>
<p class="sub">${esc(p.subtitle)}</p>
<div class="buy-price" id="buy-price"></div>
<div class="buy-step"><p class="buy-step-h">Size. <span>Each size ships from its own tested lot.</span></p>
<div class="variants" role="radiogroup" aria-label="Size">${p.variants.map((x) => {
        const lt = C.activeLot(x);
        const pr = daily ? pricing.dailyPrice(x) : x.price;
        return `<button type="button" class="variant" role="radio" aria-checked="false" data-variant="${x.id}"><div class="v-t">${esc(x.title)}</div><div class="v-p">${money(pr)}${daily ? ` <s class="faint">${money(x.price)}</s>` : ""}</div><div class="v-m">${esc(pricing.perMg(x, pr))}</div>${lt ? `<div class="v-m">LOT ${lt.number}</div>` : ""}${x.stock === 0 ? `<div class="v-m">Sold out</div>` : ""}</button>`;
      }).join("")}</div></div>
<div class="buy-step"><p class="buy-step-h">Quantity.${P.bulk.tiers.length ? ` <span>${P.bulk.tiers.map((t) => `${t.percent}% off from ${t.min} units`).join(", ")}.</span>` : ""}</p>
<div class="buy-add"><div class="stepper lg" role="group" aria-label="Quantity"><button type="button" id="q-minus" aria-label="Decrease quantity">${icon("minus")}</button><input type="number" id="q-in" min="1" max="999" value="1" inputmode="numeric" aria-label="Quantity"><button type="button" id="q-plus" aria-label="Increase quantity">${icon("plus")}</button></div><button type="button" class="btn btn-lg btn-arrow" id="add-btn">Add to cart<span class="btn-badge">${icon("bag")}</span></button></div>
<p class="small" id="line-preview" style="margin-top:12px;min-height:20px"></p></div>
<ul class="hint-list" id="hints"></ul>
<div class="lot-panel" id="lot-panel"></div>
</div>
</div></div>
<section class="section bg-canvas" id="specs" aria-labelledby="specs-title">
<div class="container">
<div class="sh reveal"><h2 class="headline" id="specs-title">What’s in the vial.</h2></div>
${SHOP.productDescription ? `<div class="panel reveal prose egr-desc" style="margin-bottom:20px">${SHOP.productDescription}</div>` : ""}
<div class="spec-grid">
<div class="panel reveal"><h3>Compound</h3><table class="spec-table" style="margin-top:12px"><tbody>${specRows(p)}</tbody></table></div>
<div class="panel reveal" style="--d:.08s" id="spec-side"></div>
</div>
<div class="notice reveal" style="margin-top:20px">${icon("warn")}<div><strong>Research use only.</strong> For in-vitro laboratory research by qualified professionals. Not for human or veterinary use. We don’t provide dosing or usage guidance.</div></div>
</div></section>
<section class="section" id="certificate" aria-labelledby="cert-title" hidden><div class="container" id="cert-root"></div></section>
<section class="section bg-canvas" aria-labelledby="rel-title" style="padding-bottom:72px"><div class="container"><div class="sh-split"><h2 class="headline-md reveal" id="rel-title">You may also study</h2><a class="more reveal" href="store.html?cat=${p.category}">More ${esc(C.catLabel(p.category).toLowerCase())} compounds</a></div></div><div id="related"></div></section>`;

      // Side panel: residue map, composition or reference
      const side = $("#spec-side");
      if (seq) {
        side.innerHTML = `<h3>Residue map</h3><p>${seq.length} residues, N- to C-terminus. Hover a residue for its position.</p>
<div class="seq-map">${seq.residues.map((r, i) => `<span class="r-${r.cls}" data-i="${i + 1}" title="${i + 1} · ${esc(r.t)}">${esc(r.t)}</span>`).join("")}</div>
<div class="legend">${EGR.residueClasses.filter(([c]) => seq.residues.some((r) => r.cls === c)).map(([c, l]) => `<span><i class="r-${c}"></i>${l}</span>`).join("")}</div>`;
      } else if (C.isBlend(p)) {
        side.innerHTML = `<h3>Composition</h3><p>Share of each component by mass, per vial.</p><div class="comp-bars" id="comp-bars"></div>`;
      } else if (p.kind === "water") {
        side.innerHTML = `<h3>Reagent</h3><p>Sterile water with 0.9 % benzyl alcohol, for reconstituting lyophilized compounds in the lab. Store at room temperature.</p>`;
      } else {
        side.innerHTML = `<h3>Structure reference</h3><p>Small-molecule or non-peptide compound. Structure and properties are listed in public databases.</p>
<p class="mono" style="font-size:24px;margin-top:24px;letter-spacing:0">${esc(p.spec.formula || "")}</p>
<p class="small muted" style="margin-top:6px">${p.spec.mw ? `${fmtNum(p.spec.mw, 2)} g/mol` : ""}</p>
${p.spec.pubchemCid ? `<div class="btn-row" style="margin-top:20px"><a class="btn btn-outline btn-sm" href="https://pubchem.ncbi.nlm.nih.gov/compound/${p.spec.pubchemCid}" target="_blank" rel="noopener">View on PubChem</a></div>` : ""}`;
      }

      function update() {
        $("#buy-stage").innerHTML = EGR.stage(p, { variant: v, large: true });
        $$("[data-thumb]").forEach((b) => b.setAttribute("aria-pressed", b.dataset.thumb === v.id));
        $$(".variant").forEach((b) => b.setAttribute("aria-checked", b.dataset.variant === v.id));
        const price = daily ? pricing.dailyPrice(v) : v.price;
        $("#buy-price").innerHTML = `<span class="big">${money(price)}</span>${daily ? `<s>${money(v.price)}</s><span class="badge badge-sale">−${P.daily.percent}% today</span>` : ""}<span class="faint small">${esc(pricing.perMg(v, price))}</span>`;
        const lt = C.activeLot(v);
        $("#lot-panel").innerHTML = lotPanel(p, v, lt);
        const cb = $("#comp-bars");
        if (cb) cb.innerHTML = p.components.map((c) => `<div class="comp-bar"><div class="lbl">${c.handle ? `<a href="product.html?p=${c.handle}">${esc(c.name)}</a>` : `<strong>${esc(c.name)}</strong>`}<span class="tnum muted">${(c.share * 100).toFixed(1)} %${v.mg ? ` · ${fmtNum(c.share * v.mg, c.share * v.mg % 1 ? 1 : 0)} mg` : ""}</span></div><div class="track"><span style="width:${c.share * 100}%"></span></div></div>`).join("");
        const cert = certSection(p, v, lt);
        $("#cert-root").innerHTML = cert;
        $("#certificate").hidden = !cert;
        const out = v.stock === 0, addBtn = $("#add-btn");
        addBtn.disabled = out;
        addBtn.firstChild.textContent = out ? "Sold out" : "Add to cart";
        addBtn.setAttribute("aria-label", out ? `${p.title} ${v.title} is sold out` : `Add ${qty} × ${p.title} ${v.title} to cart`);
        const sb = $("#stock-badge");
        if (sb) { sb.className = out ? "badge" : "badge badge-pass"; sb.innerHTML = out ? "Sold out" : `${icon("check", "icon")}In stock`; }
        const params = new URLSearchParams(location.search);
        params.delete("v");
        if (v === p.variants[0]) params.delete("variant"); else params.set("variant", v.id);
        const qsNow = params.toString();
        history.replaceState(null, "", location.pathname + (qsNow ? "?" + qsNow : ""));
        preview();
        hints();
        EGR.reveal($("#cert-root"));
      }
      function preview() {
        const pr = pricing.line(p, v, qty);
        const next = pricing.nextBulkTier(qty);
        let html = `<span class="tnum">${qty} × ${money(v.price)}</span>`;
        if (pr.discount > 0) html += ` · <span class="text-pass">${esc(pr.label)} −${pr.pct}%</span> · <strong class="tnum">${money(pr.total)}</strong> <s class="faint tnum">${money(pr.retail)}</s>`;
        else html += ` · <strong class="tnum">${money(pr.total)}</strong>`;
        if (next) html += `<br><span class="muted">Add ${next.min - qty} more for ${next.percent}% off every unit.</span>`;
        $("#line-preview").innerHTML = html;
        buyBar();
      }
      function hints() {
        const lt = C.activeLot(v);
        const items = [];
        if (daily) items.push(["clock", `<strong>On today’s list.</strong> ${P.daily.percent}% off up to ${P.daily.maxUnitsPerLine} units until midnight ET · <span class="tnum" data-countdown="daily"></span> left.`]);
        items.push(["snow", `<strong>Ships cold in 0–2 days.</strong> ${P.freeShippingOver ? `Free shipping over ${moneyShort(P.freeShippingOver)}.` : "Shipping is calculated at checkout."}`]);
        items.push(["building", `<strong>Ordering for a lab?</strong> Volume and standing orders are quoted directly. <a class="more" href="wholesale.html">Wholesale</a>`]);
        if (lt) items.push(["fileCheck", `<strong>Certificate published.</strong> This size ships from LOT ${lt.number}. <a class="more" href="lot.html?lot=${lt.number}">Read it</a>`]);
        $("#hints").innerHTML = items.map(([i, t]) => `<li>${icon(i)}<span>${t}</span></li>`).join("");
      }
      root.addEventListener("click", (e) => {
        const b = e.target.closest("[data-variant],[data-thumb]");
        if (!b) return;
        const id = b.dataset.variant || b.dataset.thumb;
        v = p.variants.find((x) => x.id === id) || v;
        update();
      });
      $(".variants").addEventListener("keydown", (e) => {
        if (!/Arrow(Right|Left|Down|Up)/.test(e.key)) return;
        e.preventDefault();
        const i = p.variants.indexOf(v);
        const j = (i + (/Right|Down/.test(e.key) ? 1 : p.variants.length - 1)) % p.variants.length;
        v = p.variants[j]; update();
        $(`.variant[data-variant="${v.id}"]`).focus();
      });
      const qIn = $("#q-in");
      const setQty = (n) => { qty = Math.max(1, Math.min(999, parseInt(n, 10) || 1)); qIn.value = qty; preview(); $("#add-btn").setAttribute("aria-label", `Add ${qty} × ${p.title} ${v.title} to cart`); };
      $("#q-minus").addEventListener("click", () => setQty(qty - 1));
      $("#q-plus").addEventListener("click", () => setQty(qty + 1));
      qIn.addEventListener("change", () => setQty(qIn.value));
      qIn.addEventListener("input", () => { const n = parseInt(qIn.value, 10); if (n >= 1) { qty = Math.min(999, n); preview(); } });
      $("#add-btn").addEventListener("click", () => {
        EGR.bag.add(v.id, qty);
        EGR.openBag();
        EGR.toast(`Added ${qty} × ${p.title} ${v.title}`);
      });

      // Mini buy bar: appears once the main button scrolls above the viewport.
      const bar = document.createElement("div");
      bar.className = "buybar";
      bar.inert = true;
      document.body.appendChild(bar);
      buyBar = () => {
        const price = daily ? pricing.dailyPrice(v) : v.price;
        bar.innerHTML = `${EGR.thumb(p, v)}<span class="grow"><b>${esc(p.title)} · ${esc(v.title)}</b><small>${money(price)}${qty > 1 ? ` · qty ${qty}` : ""}</small></span><button type="button" class="btn" data-add="${v.id}" data-qty="${qty}"${v.stock === 0 ? " disabled" : ""}>${v.stock === 0 ? "Sold out" : "Add to cart"}</button>`;
      };
      buyBar();
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(([e]) => {
          const on = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.classList.toggle("is-on", on);
          bar.inert = !on;
        }).observe($("#add-btn"));
      }

      // Related
      let rel = C.products.filter((x) => x.category === p.category && x !== p);
      if (rel.length < 4) rel = rel.concat(C.featured.filter((x) => x !== p && rel.indexOf(x) < 0)).slice(0, 8);
      $("#related").innerHTML = EGR.rail(rel.slice(0, 8).map((x) => EGR.card(x)).join(""), { label: "Related compounds" });
      update();
      EGR.springTilt($("#buy-stage"), { host: $(".buy-media"), max: 7 });
    }
  };

  function specRows(p) {
    const s = p.spec;
    const seq = EGR.parseSequence(s.sequence);
    const rows = [
      ["Compound", esc(p.title)],
      ["Category", esc(C.catLabel(p.category))],
      s.sequence ? ["Sequence", `<span class="mono" style="font-size:13px;word-break:break-all">${esc(s.sequence)}</span>`] : null,
      seq ? ["Length", `${seq.length} residues`] : null,
      s.modifications ? ["Modifications", esc(s.modifications)] : null,
      p.components ? ["Components", p.components.map((c) => `${c.handle ? `<a href="product.html?p=${c.handle}">${esc(c.name)}</a>` : esc(c.name)} <span class="faint">${(c.share * 100).toFixed(1)} %</span>`).join("<br>")] : null,
      s.mw ? ["Molecular weight", `<span class="tnum">${fmtNum(s.mw, s.mw % 1 ? Math.min(2, String(s.mw).split(".")[1].length) : 0)} g/mol</span>`] : null,
      s.formula ? ["Formula", `<span class="mono" style="font-size:13px">${esc(s.formula)}</span>`] : null,
      s.cas ? ["CAS number", `<span class="tnum">${esc(s.cas)}</span>`] : null,
      s.pubchemCid ? ["PubChem CID", `<a href="https://pubchem.ncbi.nlm.nih.gov/compound/${s.pubchemCid}" target="_blank" rel="noopener">${esc(s.pubchemCid)}</a>`] : null,
      ["Form", esc(s.form)],
      ["Storage", s.storageC <= 0 ? `${String(s.storageC).replace("-", "−")} °C, frozen, away from light` : s.storageC < 10 ? `${s.storageC} °C, refrigerated` : "Room temperature"],
      s.purityMin ? ["Purity specification", `≥ ${s.purityMin} % (RP-HPLC)`] : null,
      ["Sizes", esc(p.variants.map((v) => v.title).join(" · "))]
    ].filter(Boolean);
    return rows.map(([k, val]) => `<tr><th scope="row">${k}</th><td>${val}</td></tr>`).join("");
  }

  function identityText(p, l) {
    if (l.massObserved != null) { const [o, t] = fmtMassPair(l.massObserved, l.massTheoretical); return `<span class="ok-ic">${icon("check")}</span>${o} / ${t} Da`; }
    if (C.isBlend(p)) return `<span class="ok-ic">${icon("check")}</span>${p.components.length} components confirmed`;
    return `<span class="ok-ic">${icon("check")}</span>Conforms`;
  }
  EGR.identityText = identityText;

  function lotPanel(p, v, l) {
    if (!l) return "";
    return `<div class="lot-panel-head"><p class="title tnum"><span class="lp-pre">Ships from</span> LOT ${l.number}</p><span class="stamp">${icon("check", "icon")} Released</span></div>
<dl class="kv">
<div><dt>Purity (HPLC)</dt><dd>${l.purity != null ? `<span class="text-pass">${l.purity.toFixed(2)} %</span>` : "n/a · reagent"}</dd></div>
<div><dt>Identity (MS)</dt><dd>${identityText(p, l)}</dd></div>
<div><dt>Appearance</dt><dd>${esc(C.appearance(p))}</dd></div>
<div><dt>Tested</dt><dd>${fmtDate(l.testedAt)}</dd></div>
</dl>
<a class="more small" style="display:inline-block;margin-top:12px" href="lot.html?lot=${l.number}">Read the full certificate</a>`;
  }

  function certSection(p, v, l) {
    const lots = p.variants.flatMap((x) => x.lots.map((lt) => ({ lt, x }))).sort((a, b) => b.lt.testedAt.localeCompare(a.lt.testedAt));
    if (!lots.length) return ""; // no published certificates for this product yet
    const hist = `<div class="history">${lots.map(({ lt, x }) => `<a href="lot.html?lot=${lt.number}"><span><strong>LOT ${lt.number}</strong> <span class="faint">· ${esc(x.title)} · ${fmtDate(lt.testedAt)}</span></span><span>${lt.purity != null ? `<span class="text-pass">${lt.purity.toFixed(2)} %</span>` : ""} ${lt.status === "archived" ? '<span class="badge badge-archived">Archived</span>' : '<span class="badge badge-pass">Released</span>'}</span></a>`).join("")}</div>`;
    const chart = l && l.purity != null
      ? `<div class="coa-card"><div class="coa-card-head"><p class="title">${esc(p.title)} · ${esc(v.title)} chromatogram</p><span class="badge tnum">LOT ${l.number}</span></div><figure style="margin-top:20px">${EGR.chrom.svg(EGR.chrom.data(l.number, l.purity), { animate: !reduce })}<figcaption class="chrom-cap"><span>Retention time (min)</span><span>${esc(l.method)}</span></figcaption></figure></div>`
      : `<div class="coa-card"><p class="title">${esc(p.title)} · ${esc(v.title)} certificate</p><p class="muted" style="margin-top:12px">Chromatographic purity isn’t applicable to this reagent. Its certificate records identity and appearance.</p></div>`;
    return `<div class="split" style="align-items:start">
<div class="reveal"><h2 class="headline" id="cert-title">The lot, <span class="dim">on the record.</span></h2>
<p class="lede muted" style="margin-top:14px">This size ships from LOT ${l ? l.number : ""}, tested ${l ? fmtDate(l.testedAt) : ""}. The lot number is printed on your vial.</p>
<div class="btn-row" style="margin-top:24px">${l ? `<a class="btn" href="lot.html?lot=${l.number}">Read the full certificate</a>` : ""}<a class="more" href="coa.html?q=${encodeURIComponent(p.short)}">All lots for ${esc(p.short)}</a></div>
<h3 class="title" style="margin-top:40px">Lot history</h3>${hist}</div>
<div class="reveal" style="--d:.1s">${chart}</div></div>`;
  }

  /* ================================================================== BOX */
  const DRAFT = "egr_box_draft";
  EGR.pages.box = {
    title: "Build a monthly box · EGR",
    init() {
      const N = P.box.slots;
      let picks = (storage(DRAFT) || []).filter((id) => C.variant(id)).slice(0, N);
      const pre = qs("add");
      if (pre && C.variant(pre) && picks.length < N && !sessionStorage.getItem("egr_box_pre_" + pre)) {
        picks.push(pre);
        try { sessionStorage.setItem("egr_box_pre_" + pre, "1"); } catch (e) { /* ignore */ }
      }
      const gift = C.product(P.box.freeGiftHandle);
      const choices = C.products.filter((p) => p.category !== "supplies");
      $("#box-head").innerHTML = `Pick any ${N}.<br><span class="grad">Save ${P.box.percent}% every month.</span>`;
      $("#box-lede").textContent = `Choose ${N} compounds from the catalog. We pack and ship them every month at ${P.box.percent}% off retail, with a free ${gift ? gift.title : "reagent"} and free 2-day delivery.`;
      $("#how-steps").innerHTML = [
        ["Pick " + N, `Any ${N} compounds and sizes. Doubles are fine.`],
        [`Save ${P.box.percent}%`, "Box pricing applies to every compound, every month."],
        ["Ships monthly", `Cold-packed with a free ${gift ? gift.title : "reagent"}. Free 2-day delivery.`],
        ["Swap or cancel", `Swap anything once your first box ships. Cancel after ${P.box.deliveries} deliveries.`]
      ].map(([h, t]) => `<li><h3>${h}</h3><p>${t}</p></li>`).join("");

      const grid = $("#pick-grid");
      grid.innerHTML = choices.map((p) => {
        const v = p.variants[0];
        return `<div class="pick" data-handle="${p.handle}">
<span class="badge badge-blue in-box" hidden></span>
<a class="stage tone-${p.tone}" href="product.html?p=${p.handle}" aria-label="${esc(p.title)} details">${EGR.stage(p, { variant: v })}</a>
<div class="pick-body"><div><p class="n">${esc(p.title)}</p><p class="p" data-price></p></div>
${p.variants.length > 1 ? `<select class="select-sm input" aria-label="Size for ${esc(p.title)}" data-size>${p.variants.map((x) => `<option value="${x.id}">${esc(x.title)}</option>`).join("")}</select>` : `<input type="hidden" data-size value="${v.id}">`}
<button type="button" class="btn btn-sm btn-outline" data-pick>Add to box</button></div></div>`;
      }).join("");

      function priceFor(id) { const x = C.variant(id); return round2(x.variant.price * (1 - P.box.percent / 100)); }
      function render() {
        storage(DRAFT, picks);
        const full = picks.length >= N;
        $$(".pick", grid).forEach((card) => {
          const sel = $("[data-size]", card);
          const id = sel.value;
          const x = C.variant(id);
          $("[data-price]", card).innerHTML = `${money(priceFor(id))}/mo <s>${money(x.variant.price)}</s>`;
          const p = C.product(card.dataset.handle);
          const n = picks.filter((pid) => C.variant(pid).product === p).length;
          const badge = $(".in-box", card);
          badge.hidden = !n; badge.textContent = n > 1 ? `In box ×${n}` : "In box";
          const b = $("[data-pick]", card);
          b.disabled = full;
          b.textContent = full ? "Box is full" : "Add to box";
        });
        const slots = $("#aside-slots");
        let html = "";
        for (let i = 0; i < N; i++) {
          const id = picks[i];
          if (id) {
            const x = C.variant(id);
            html += `<div class="aside-slot is-filled">${EGR.thumb(x.product, x.variant)}<span class="grow"><b>${esc(x.product.title)}</b><small>${esc(x.variant.title)} · ${money(priceFor(id))}/mo</small></span><button type="button" class="icon-btn" data-unpick="${i}" aria-label="Remove ${esc(x.product.title)} from box">${icon("close")}</button></div>`;
          } else {
            html += `<div class="aside-slot"><span class="num">${i + 1}</span><span class="grow">Empty slot</span></div>`;
          }
        }
        slots.innerHTML = html;
        const t = pricing.box(picks);
        $("#box-n").textContent = `${picks.length}/${N} picked`;
        $("#box-bar").style.width = (picks.length / N) * 100 + "%";
        $("#box-bar").parentElement.setAttribute("aria-valuenow", picks.length);
        $("#box-gift").classList.toggle("is-on", full);
        $("#box-retail").textContent = money(t.retail);
        $("#box-total").textContent = money(t.total);
        $("#box-save").textContent = t.discount ? `You save ${money(t.discount)} every month` : `Save ${P.box.percent}% on every compound`;
        const add = $("#box-add");
        add.disabled = !full;
        add.textContent = full ? `Add box to cart · ${money(t.total)}/mo` : `Pick ${N - picks.length} more`;
      }
      grid.addEventListener("change", (e) => { if (e.target.matches("[data-size]")) render(); });
      grid.addEventListener("click", (e) => {
        const b = e.target.closest("[data-pick]");
        if (!b || picks.length >= N) return;
        const card = b.closest(".pick");
        picks.push($("[data-size]", card).value);
        render();
        EGR.toast(`${C.variant(picks[picks.length - 1]).product.title} added to your box`);
      });
      $("#aside-slots").addEventListener("click", (e) => {
        const b = e.target.closest("[data-unpick]");
        if (!b) return;
        picks.splice(parseInt(b.dataset.unpick, 10), 1);
        render();
      });
      $("#box-clear").addEventListener("click", () => { picks = []; render(); });
      $("#box-add").addEventListener("click", () => {
        if (picks.length < N) return;
        EGR.bag.addBox(picks);
        picks = [];
        render();
        EGR.openBag();
        EGR.toast("Monthly box added to your cart");
      });
      if (gift) $("#box-gift").innerHTML = `${EGR.thumb(gift)}<span class="grow">${esc(gift.title)} <span>included every month</span></span><span class="free">FREE</span>`;
      $("#box-terms").textContent = `Billed monthly. ${P.box.deliveries} deliveries to start, then cancel anytime. Free 2-day delivery.`;
      $("#box-faq").innerHTML = EGR.faqHtml([
        ["Can I pick the same compound twice?", "Yes. Each slot is independent, so you can fill two or more slots with the same compound or different sizes of it."],
        ["Can I change what’s in my box?", "Once your first box ships you can swap any compound for the next delivery. Every vial still ships with the certificate for its own lot."],
        ["When can I cancel?", `Boxes start with ${P.box.deliveries} monthly deliveries. After that you can cancel anytime before the next one ships.`],
        [`Is the free ${gift ? gift.title : "reagent"} included every month?`, `Yes. Every box includes a 10 mL ${gift ? gift.title : "reagent"} at no charge, plus free 2-day cold-packed delivery.`]
      ], { single: true });
      render();
    }
  };

  /* ================================================================= BULK */
  EGR.pages.bulk = {
    title: "Bulk orders · EGR",
    init() {
      const [t1, t2] = P.bulk.tiers;
      $("#bulk-head").innerHTML = `Stocking up?<br><span class="grad">Up to ${t2.percent}% off</span> in bulk.`;
      $("#bulk-lede").textContent = `${t1.min}+ units of any compound takes ${t1.percent}% off every unit. Reach ${t2.min} and the whole line drops to ${t2.percent}%. Same lots, same certificates, one order.`;
      $("#bulk-tiers").innerHTML = `<li class="tier-chip dark">${t1.min}+ units · ${t1.percent}% off</li><li class="tier-chip">${t2.min}+ units · ${t2.percent}% off</li><li class="tier-chip">Free 2-day signed delivery</li>`;

      const selP = $("#bulk-product"), selV = $("#bulk-size"), range = $("#bulk-range"), qIn = $("#bulk-qty");
      selP.innerHTML = EGR.data.categories.map((c) => {
        const items = C.products.filter((p) => p.category === c.id);
        return items.length ? `<optgroup label="${esc(c.label)}">${items.map((p) => `<option value="${p.handle}">${esc(p.title)}</option>`).join("")}</optgroup>` : "";
      }).join("");
      const start = C.product(qs("p")) || C.product("reditide");
      selP.value = start.handle;
      let p = start, v = p.variants[0], qty = parseInt(qs("qty"), 10) || t1.min;
      const max = 100;
      $("#tier-marks").innerHTML = P.bulk.tiers.map((t) => `<span class="mark" style="left:${(t.min / max) * 100}%"><span>${t.min}+ · ${t.percent}%</span></span>`).join("");
      function sizes() {
        selV.innerHTML = p.variants.map((x) => `<option value="${x.id}">${esc(x.title)} · ${money(x.price)}</option>`).join("");
        selV.value = v.id;
        selV.disabled = p.variants.length < 2;
      }
      function render() {
        qIn.value = qty;
        range.value = Math.min(max, qty);
        $("#tier-fill").style.width = Math.min(100, (qty / max) * 100) + "%";
        const pr = pricing.line(p, v, qty);
        const unit = pr.total / qty;
        const next = pricing.nextBulkTier(qty);
        $("#bulk-art").innerHTML = `<span class="stage tone-${p.tone}" style="border-radius:var(--r-lg)">${EGR.stage(p, { variant: v })}</span>`;
        $("#bulk-out").innerHTML = `<p class="eyebrow-sm">${esc(p.title)} · ${esc(v.title)} × ${qty}</p>
<p class="big-num" style="margin-top:8px">${money(pr.total)}</p>
<p class="muted tnum" style="margin-top:6px">${money(unit)} per unit${pr.discount ? ` · <s>${money(pr.retail)}</s>` : ""}</p>
${pr.discount ? `<p class="badge badge-pass" style="margin-top:14px">${esc(pr.label)} · save ${money(pr.discount)}</p>` : `<p class="badge" style="margin-top:14px">Retail pricing</p>`}
<p class="small muted" style="margin-top:14px">${next ? `Add <strong>${next.min - qty}</strong> more to unlock ${next.percent}% off every unit.` : `Top tier unlocked: ${t2.percent}% off every unit.`}${pricing.isDaily(p) && P.daily.percent > (pricing.bulkTier(qty) || { percent: 0 }).percent ? ` On today’s list, the first ${P.daily.maxUnitsPerLine} units are half price.` : ""}</p>`;
        const add = $("#bulk-add");
        add.dataset.add = v.id;
        add.dataset.qty = qty;
        add.textContent = `Add ${qty} to cart`;
      }
      selP.addEventListener("change", () => { p = C.product(selP.value); v = p.variants[0]; sizes(); render(); });
      selV.addEventListener("change", () => { v = p.variants.find((x) => x.id === selV.value) || v; render(); });
      range.addEventListener("input", () => { qty = parseInt(range.value, 10) || 1; render(); });
      qIn.addEventListener("change", () => { qty = Math.max(1, Math.min(999, parseInt(qIn.value, 10) || 1)); render(); });
      $("#bulk-minus").addEventListener("click", () => { qty = Math.max(1, qty - 1); render(); });
      $("#bulk-plus").addEventListener("click", () => { qty = Math.min(999, qty + 1); render(); });
      $$("[data-preset]").forEach((b) => b.addEventListener("click", () => { qty = parseInt(b.dataset.preset, 10); render(); }));
      sizes(); render();

      $("#price-table").innerHTML = `<div class="table-card"><div class="table-scroll"><table class="lot-table"><thead><tr><th scope="col">Compound</th><th scope="col">Size</th><th scope="col">Retail</th><th scope="col">${t1.min}+ units</th><th scope="col">${t2.min}+ units</th><th scope="col" class="hide-sm">Per mg at ${t2.min}+</th></tr></thead><tbody>${C.products.flatMap((pp) => pp.variants.map((x) => `<tr data-href="product.html?p=${pp.handle}${x !== pp.variants[0] ? "&v=" + sizeSlug(x) : ""}"><td><div class="cmp">${EGR.thumb(pp, x)}<span class="cmp-name">${esc(pp.title)}</span></div></td><td class="tnum">${esc(x.title)}</td><td class="tnum">${money(x.price)}</td><td class="tnum">${money(pricing.unitAt(x, t1.percent))}</td><td class="tnum text-pass" style="font-weight:600">${money(pricing.unitAt(x, t2.percent))}</td><td class="tnum muted hide-sm">${esc(pricing.perMg(x, pricing.unitAt(x, t2.percent)))}</td></tr>`)).join("")}</tbody></table></div></div>`;
    }
  };

  /* ============================================================= CHECKOUT */
  EGR.pages.checkout = {
    title: "Checkout · EGR",
    init() {
      const root = $("#checkout");
      function summary() {
        const t = EGR.bag.totals();
        if (!t.lines.length) return null;
        const lines = t.lines.map((l) => {
          if (l.t === "box") {
            const first = C.variant(l.items[0]);
            return `<div class="bag-line">${first ? EGR.thumb(first.product, first.variant) : ""}<div class="grow"><div class="t"><span>Monthly box</span><span class="amt">${money(l.lineTotal)}/mo</span></div><div class="s">${l.items.map((id) => { const x = C.variant(id); return x ? `${esc(x.product.short)} ${esc(x.variant.title)}` : ""; }).join(" · ")}</div></div></div>`;
          }
          return `<div class="bag-line">${EGR.thumb(l.product, l.variant)}<div class="grow"><div class="t"><span>${esc(l.product.title)}</span><span class="amt">${money(l.lineTotal)}</span></div><div class="s">${esc(l.variant.title)} · Qty ${l.q}${l.pricing.label ? ` · <span class="text-pass">${esc(l.pricing.label)}</span>` : ""}</div></div></div>`;
        }).join("");
        return `<div class="panel"><h3>Order summary</h3><div style="margin-top:8px">${lines}</div>
<div class="sum" style="margin-top:12px"><div><span>Subtotal</span><span>${money(t.retail)}</span></div>${t.savings.map((s) => `<div><span>${esc(s.label)}</span><span class="neg">−${money(s.amount)}</span></div>`).join("")}<div><span>Shipping</span><span>${t.freeShipping ? "Free 2-day" : "Rate not set yet"}</span></div><div class="total"><span>Total</span><span>${money(t.total)}</span></div></div>
<button type="button" class="linkish" style="margin-top:14px;font-size:14px" data-open-bag>Edit cart</button></div>`;
      }
      function render() {
        const s = summary();
        if (!s) {
          root.innerHTML = `<div class="empty" style="padding:120px 12px">${icon("bag", "icon-lg")}<h3>Your cart is empty.</h3><p>Add a compound to check out.</p><div class="btn-row"><a class="btn" href="store.html">Shop the catalog</a></div></div>`;
          return false;
        }
        const aside = $("#checkout-aside");
        if (aside) { aside.innerHTML = s; return true; }
        root.innerHTML = `<div class="checkout">
<form id="co-form" novalidate>
<h1 class="headline-md" style="margin-bottom:32px">Checkout</h1>
<fieldset><legend>Contact</legend><div class="form-grid">
<label class="field"><span class="field-label">Email</span><input class="input" type="email" name="email" autocomplete="email" required></label>
<label class="field"><span class="field-label">Institution or lab <span class="faint" style="font-weight:400">(optional)</span></span><input class="input" name="organization" autocomplete="organization"></label>
</div></fieldset>
<fieldset><legend>Shipping address</legend><div class="form-grid two">
<label class="field"><span class="field-label">First name</span><input class="input" name="given" autocomplete="given-name" required></label>
<label class="field"><span class="field-label">Last name</span><input class="input" name="family" autocomplete="family-name" required></label>
</div><div class="form-grid" style="margin-top:14px">
<label class="field"><span class="field-label">Street address</span><input class="input" name="address" autocomplete="address-line1" required></label>
<label class="field"><span class="field-label">Apt, suite <span class="faint" style="font-weight:400">(optional)</span></span><input class="input" name="address2" autocomplete="address-line2"></label>
</div><div class="form-grid two" style="margin-top:14px">
<label class="field"><span class="field-label">City</span><input class="input" name="city" autocomplete="address-level2" required></label>
<label class="field"><span class="field-label">State</span><input class="input" name="state" autocomplete="address-level1" required></label>
<label class="field"><span class="field-label">ZIP code</span><input class="input" name="zip" autocomplete="postal-code" inputmode="numeric" required></label>
<label class="field"><span class="field-label">Country</span><select class="input" name="country" autocomplete="country"><option>United States</option></select></label>
</div></fieldset>
<fieldset><legend>Delivery</legend><div class="check is-checked" style="cursor:default"><span class="box">${icon("check")}</span><span><strong>2-day, cold-packed</strong><br><span class="muted">Dispatched by 2 pm ET on business days. ${EGR.bag.totals().freeShipping ? "Free on this order." : `Free on orders over ${moneyShort(P.freeShippingOver)}.`}</span></span></div></fieldset>
<fieldset><legend>Research use</legend>
<label class="check"><input type="checkbox" name="ruo" required><span class="box">${icon("check")}</span><span>I confirm this order is for in-vitro laboratory research only, not for human or veterinary use, and I accept the <a href="legal.html?doc=terms">terms of sale</a>.</span></label>
</fieldset>
<fieldset><legend>Payment</legend><div class="notice info">${icon("info")}<div><strong>Payment provider not connected yet.</strong> This storefront doesn’t take payments until a processor is wired up. Your cart is saved on this device.</div></div></fieldset>
<button type="submit" class="btn btn-lg btn-block">Review order</button>
<p class="form-note" aria-live="polite"></p>
</form>
<aside class="checkout-aside" id="checkout-aside">${s}</aside></div>`;
        const form = $("#co-form");
        $$(".check input", form).forEach((x) => x.addEventListener("change", () => x.closest(".check").classList.toggle("is-checked", x.checked)));
        form.addEventListener("submit", (e) => {
          e.preventDefault();
          const note = $(".form-note", form);
          if (!form.checkValidity()) { form.reportValidity(); note.textContent = "Fill in the highlighted fields to continue."; note.classList.remove("ok"); return; }
          note.textContent = "Details look good. Connect a payment provider to take this order live.";
          note.classList.add("ok");
        });
        return true;
      }
      render();
      EGR.bag.on(() => { if (!render()) { /* emptied */ } });
    }
  };
})();
